import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { listMyTeams } from '../../team/teamApi';

/**
 * True when GET /users/{userId}/teams reports role "strategist" for teamId.
 * Uses UserTeamResponse.role from the teams endpoint.
 */
export function useIsStrategist(teamId: string | undefined): boolean {
  const { user } = useAuth();
  const [isStrategist, setIsStrategist] = useState(false);

  useEffect(() => {
    if (!user?.id || !teamId) {
      setIsStrategist(false);
      return;
    }

    let cancelled = false;
    listMyTeams(user.id)
      .then((teams) => {
        if (cancelled) return;
        const membership = teams.find((t) => t.id === teamId);
        setIsStrategist(membership?.role === 'strategist');
      })
      .catch(() => {
        if (!cancelled) setIsStrategist(false);
      });

    return () => {
      cancelled = true;
    };
  }, [user?.id, teamId]);

  return useMemo(() => isStrategist, [isStrategist]);
}
